"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function PieChartTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'pie-chart',
    theme: 'twotone',
    nameWithTheme: 'pie-chart-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7-36.7-36.7-65.6-79.5-85.7-127.1C82.6 658.5 72 606.2 72 552.2v.2c0 54 10.6 106.2 31.4 155.5 20.1 47.5 48.9 90.3 85.6 127s79.4 65.5 127 85.6c49.3 20.9 101.7 31.5 155.6 31.5 27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1-45.7-45.6-103.8-76.7-166.4-89.8z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        d: 'M864 518H506V160c0-4.4-3.6-8-8-8h-26c-54 0-106.4 10.6-155.7 31.4-47.6 20.1-90.4 49-127.1 85.7s-65.6 79.5-85.7 127.1C82.6 445.6 72 498 72 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7C365.6 941.4 418 952 472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1C861.4 658.4 872 606 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8c-62.6 62.1-147.1 96.6-235.3 96.2-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z',
        fill: primaryColor
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        d: 'M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6-65.8-65.7-152.8-106.5-245.2-115L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3-.5 1.1-.9 2.3-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7 2.9-1.4 4.9-4.5 4.6-7.9zm-332.2-58.2V147.6c62.6 13.1 120.7 44.2 166.4 89.8 45.7 45.6 77 103.6 90 166.1l-256.4.7z',
        fill: primaryColor
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'pie-chart-twotone';
var PieChartTwoTone = temp;
exports.default = PieChartTwoTone;